import React from 'react';
import Select from 'react-select';
import {
  notificationOptions,
  formSummaryRecipientOptions,
  timeOptions,
  formSummarySendingTimesOptions,
  formSummaryStopType,
  formSummarySendingValueOptions,
  formSummaryStopPeriodTimesOptions,
} from '../../../../../constants/forms/options';
import DatePicker from 'react-datepicker';
import MultiDatePicker, { DateObject } from 'react-multi-date-picker';

const FormSummarySettings = ({ handelSettings, notifications_settings, errors }) => {
  const handleSelectWeekDays = (weekDay) => {
    if (notifications_settings.form_summary_notification_sending_week_days) {
      if (!notifications_settings.form_summary_notification_sending_week_days.includes(weekDay)) {
        handelSettings(
          [...notifications_settings.form_summary_notification_sending_week_days, weekDay],
          'form_summary_notification_sending_week_days',
        );
      } else {
        handelSettings(
          notifications_settings.form_summary_notification_sending_week_days.filter((item) => item !== weekDay),
          'form_summary_notification_sending_week_days',
        );
      }
    }
  };

  return (
    <>
      <div className="form-control-item-group">
        <label className="form-label">Notification recipients</label>
        <div className="select-multy-wrapper">
          <Select
            hideSelectedOptions={false}
            isSearchable={false}
            options={formSummaryRecipientOptions}
            value={notifications_settings.form_summary_recipient_type}
            onChange={(e) => handelSettings(e, 'form_summary_recipient_type')}
            className="form-control-select"
            placeholder="Select who will be notified"
            classNamePrefix="react-select"
          ></Select>
          <span className="form-error">{errors?.form_summary_recipient_type && errors.form_summary_recipient_type[0]}</span>
        </div>
      </div>

      <div className="form-control-item-group">
        <label className="form-label">Form summary notification type</label>
        <div className="select-multy-wrapper">
          <Select
            hideSelectedOptions={false}
            isSearchable={false}
            options={notificationOptions}
            value={notifications_settings.form_summary_notification_type}
            onChange={(e) => handelSettings(e, 'form_summary_notification_type')}
            className="form-control-select"
            placeholder="SMS / Email"
            classNamePrefix="react-select"
          ></Select>
          <span className="form-error">{errors?.form_summary_notification_type && errors.form_summary_notification_type[0]}</span>
        </div>
      </div>

      <div className="form-control-item-group">
        <p>Checklist with information that should be added to the Form Summary notification:</p>
        <div className={`form-control-checkbox `}>
          <input
            type="checkbox"
            onChange={(e) => handelSettings(!notifications_settings.form_summary_send_form_completion, 'form_summary_send_form_completion')}
            checked={notifications_settings.form_summary_send_form_completion}
          />
          <span>form completion percentage</span>
        </div>
        <div className={`form-control-checkbox`}>
          <input
            type="checkbox"
            onChange={(e) =>
              handelSettings(
                !notifications_settings.form_summary_send_amount_of_people_who_submitted_form,
                'form_summary_send_amount_of_people_who_submitted_form',
              )
            }
            checked={notifications_settings.form_summary_send_amount_of_people_who_submitted_form}
          />
          <span>amount of people who submitted the form</span>
        </div>
        <div className={`form-control-checkbox`}>
          <input
            type="checkbox"
            onChange={(e) =>
              handelSettings(
                !notifications_settings.form_summary_send_amount_of_people_who_did_not_submit_form,
                'form_summary_send_amount_of_people_who_did_not_submit_form',
              )
            }
            checked={notifications_settings.form_summary_send_amount_of_people_who_did_not_submit_form}
          />
          <span>amount of people who didn`t submit the form</span>
        </div>
        <div className={`form-control-checkbox`}>
          <input
            type="checkbox"
            onChange={(e) =>
              handelSettings(
                !notifications_settings.form_summary_send_list_of_people_who_submitted_form,
                'form_summary_send_list_of_people_who_submitted_form',
              )
            }
            checked={notifications_settings.form_summary_send_list_of_people_who_submitted_form}
          />
          <span>the list of people who submitted the form</span>
        </div>
        <div className={`form-control-checkbox`}>
          <input
            type="checkbox"
            onChange={(e) =>
              handelSettings(
                !notifications_settings.form_summary_send_list_of_people_who_did_not_submit_form,
                'form_summary_send_list_of_people_who_did_not_submit_form',
              )
            }
            checked={notifications_settings.form_summary_send_list_of_people_who_did_not_submit_form}
          />
          <span>the list of people who didn`t submit the form</span>
        </div>
      </div>

      <div className="form-control-item-group">
        <label className="form-label">Repeat every</label>
        <div className="d-flex gap-3">
          <div className="form-control-item-half">
            <Select
              hideSelectedOptions={false}
              isSearchable={false}
              options={formSummarySendingTimesOptions}
              value={notifications_settings.form_summary_notification_sending_times}
              onChange={(e) => handelSettings(e, 'form_summary_notification_sending_times')}
              className="form-control-select"
              placeholder="Select quantity"
              classNamePrefix="react-select"
            ></Select>
            <span className="form-error">
              {errors?.form_summary_notification_sending_times && errors.form_summary_notification_sending_times[0]}
            </span>
          </div>

          <div className="form-control-item-half">
            <Select
              hideSelectedOptions={false}
              isSearchable={false}
              options={formSummarySendingValueOptions}
              value={notifications_settings.form_summary_notification_sending_value}
              onChange={(e) => handelSettings(e, 'form_summary_notification_sending_value')}
              className="form-control-select"
              placeholder="Period"
              classNamePrefix="react-select"
            ></Select>
            <span className="form-error">
              {errors?.form_summary_notification_sending_value && errors.form_summary_notification_sending_value[0]}
            </span>
          </div>
        </div>
      </div>

      {notifications_settings.form_summary_notification_sending_value?.value == 'weekly' && (
        <div className={'form-item mb-6'}>
          <label htmlFor="">Send on these days:</label>
          <div className={'week-grid'}>
            <div className={'form-control-checkbox-span'}>
              <input
                type="checkbox"
                checked={notifications_settings.form_summary_notification_sending_week_days?.includes(0)}
                onChange={(e) => handleSelectWeekDays(0)}
              />{' '}
              <span>Sun</span>
            </div>
            <div className={'form-control-checkbox-span'}>
              <input
                type="checkbox"
                checked={notifications_settings.form_summary_notification_sending_week_days?.includes(1)}
                onChange={(e) => handleSelectWeekDays(1)}
              />{' '}
              <span>Mon</span>
            </div>
            <div className={'form-control-checkbox-span'}>
              <input
                type="checkbox"
                checked={notifications_settings.form_summary_notification_sending_week_days?.includes(2)}
                onChange={(e) => handleSelectWeekDays(2)}
              />{' '}
              <span>Tue</span>
            </div>
            <div className={'form-control-checkbox-span'}>
              <input
                type="checkbox"
                checked={notifications_settings.form_summary_notification_sending_week_days?.includes(3)}
                onChange={(e) => handleSelectWeekDays(3)}
              />{' '}
              <span>Wed</span>
            </div>
            <div className={'form-control-checkbox-span'}>
              <input
                type="checkbox"
                checked={notifications_settings.form_summary_notification_sending_week_days?.includes(4)}
                onChange={(e) => handleSelectWeekDays(4)}
              />{' '}
              <span>Thu</span>
            </div>
            <div className={'form-control-checkbox-span'}>
              <input
                type="checkbox"
                checked={notifications_settings.form_summary_notification_sending_week_days?.includes(5)}
                onChange={(e) => handleSelectWeekDays(5)}
              />{' '}
              <span>Fri</span>
            </div>
            <div className={'form-control-checkbox-span'}>
              <input
                type="checkbox"
                checked={notifications_settings.form_summary_notification_sending_week_days?.includes(6)}
                onChange={(e) => handleSelectWeekDays(6)}
              />{' '}
              <span>Sat</span>
            </div>
          </div>
          <span className="form-error">
            {errors?.form_summary_notification_sending_week_days && errors.form_summary_notification_sending_week_days[0]}
          </span>
        </div>
      )}

      {notifications_settings.form_summary_notification_sending_value?.value == 'monthly' && (
        <div className={'form-item multi-date-picker disabled-change-month mb-6'}>
          <label className="form-label">Send on days</label>
          <div className={'clear-datepicker'}>
            <MultiDatePicker
              multiple
              format={'DD'}
              editable={false}
              placeholder={'Choose Days'}
              currentDate={
                new DateObject({
                  year: 2024,
                  month: 12,
                  day: 1,
                })
              }
              value={notifications_settings.form_summary_notification_sending_month_days}
              onChange={(dates) => {
                handelSettings(
                  dates.map((value) => value),
                  'form_summary_notification_sending_month_days',
                );
              }}
            />
            {notifications_settings.form_summary_notification_sending_month_days?.length > 0 && (
              <button onClick={() => handelSettings([], 'form_summary_notification_sending_month_days')} className={'clear'}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <g clipPath="url(#clip0_5205_22763)">
                    <path
                      d="M12.5001 7.5013L7.50008 12.5013M7.50008 7.5013L12.5001 12.5013M18.3334 10.0013C18.3334 14.6037 14.6025 18.3346 10.0001 18.3346C5.39771 18.3346 1.66675 14.6037 1.66675 10.0013C1.66675 5.39893 5.39771 1.66797 10.0001 1.66797C14.6025 1.66797 18.3334 5.39893 18.3334 10.0013Z"
                      stroke="#D92D20"
                      strokeWidth="1.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_5205_22763">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
            )}
          </div>
          <span className="form-error">
            {errors?.form_summary_notification_sending_month_days && errors.form_summary_notification_sending_month_days[0]}
          </span>
        </div>
      )}

      <div className="form-control-item-group form-item-time">
        <label className="form-label">Time</label>
        <Select
          hideSelectedOptions={false}
          isSearchable={false}
          options={timeOptions}
          value={notifications_settings.form_summary_notification_send_at_time}
          onChange={(e) => handelSettings(e, 'form_summary_notification_send_at_time')}
          className="form-control-select"
          placeholder="Period"
          classNamePrefix="react-select"
        ></Select>
        <span className="form-error">
          {errors?.form_summary_notification_send_at_time && errors.form_summary_notification_send_at_time[0]}
        </span>
      </div>

      <div className="form-control-item-group">
        <label className="form-label">When Form Summary notifications should stop being sent</label>
        <Select
          hideSelectedOptions={false}
          isSearchable={false}
          options={formSummaryStopType}
          value={notifications_settings.form_summary_notification_stop_type}
          onChange={(e) => handelSettings(e, 'form_summary_notification_stop_type')}
          className="form-control-select"
          menuPlacement="auto"
          placeholder="Choose"
          classNamePrefix="react-select"
        ></Select>
        <span className="form-error">{errors?.form_summary_notification_stop_type && errors.form_summary_notification_stop_type[0]}</span>
      </div>

      {notifications_settings.form_summary_notification_stop_type?.value === 'specific_date' && (
        <div className="form-control-item-group">
          <label className="form-label">Date</label>
          <DatePicker
            selected={notifications_settings.form_summary_notification_stop_on_date}
            className="form-control date-picker"
            onChange={(date) => handelSettings(date, 'form_summary_notification_stop_on_date')}
            isClearable
            disabledKeyboardNavigation
            placeholderText={'Choose Date'}
          ></DatePicker>
          <span className="form-error">
            {errors?.form_summary_notification_stop_on_date && errors.form_summary_notification_stop_on_date[0]}
          </span>
        </div>
      )}

      {notifications_settings.form_summary_notification_stop_type?.value === 'interval' && (
        <div className="form-control-item-group">
          <label className="form-label">Choose period</label>
          <div className="d-flex gap-3">
            <div className="form-control-item-half">
              <Select
                hideSelectedOptions={false}
                isSearchable={false}
                menuPlacement="top"
                options={formSummaryStopPeriodTimesOptions}
                value={notifications_settings.form_summary_notification_stop_period_times}
                onChange={(e) => handelSettings(e, 'form_summary_notification_stop_period_times')}
                className="form-control-select"
                placeholder="Select period"
                classNamePrefix="react-select"
              ></Select>
              <span className="form-error">
                {errors?.form_summary_notification_stop_period_times && errors.form_summary_notification_stop_period_times[0]}
              </span>
            </div>

            <div className="form-control-item-half">
              <Select
                hideSelectedOptions={false}
                isSearchable={false}
                menuPlacement="top"
                options={formSummarySendingValueOptions}
                value={notifications_settings.form_summary_notification_stop_period_value}
                onChange={(e) => handelSettings(e, 'form_summary_notification_stop_period_value')}
                className="form-control-select"
                placeholder="Period"
                classNamePrefix="react-select"
              ></Select>
              <span className="form-error">
                {errors?.form_summary_notification_stop_period_value && errors.form_summary_notification_stop_period_value[0]}
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FormSummarySettings;
